const HoldingDispositionResultEnum = Object.freeze({
    NONE: 'NONE',
    SOLD: 'SOLD',
    EXIT: 'EXIT',
    FAIL: 'FAIL',
    MERGED: 'MERGED'
});

export default HoldingDispositionResultEnum;
